import React, { useState } from 'react';

const LEGACY_PRA_URL = 'https://pra.levelupgroup.nl/';
const FEEDBACK_MAILTO = 'mailto:jaspermarcusse@levelupgroup.nl';
const PRA_BOARD_FORM_URL =
    'https://form.asana.com/?k=Rgow6SCQ4XghVg_K3nA24g&d=17714717996195';

export default function NewVersionNotice() {
    const [infoOpen, setInfoOpen] = useState(false);

    return (
        <aside
            className={`new-version-notice${infoOpen ? ' is-open' : ''}`}
            aria-label="Melding over de nieuwe PRA-versie"
        >
            <p className="new-version-notice__text">
                Je bent in de nieuwe versie van de PRA. Terug naar de oude versie:{' '}
                <a href={LEGACY_PRA_URL} target="_blank" rel="noopener noreferrer">
                    pra.levelupgroup.nl                </a>
                .
            </p>
            <span className="new-version-notice__info-wrap">
                <button
                    type="button"
                    className="new-version-notice__info"
                    aria-label="Meer informatie over terugkeren naar de oude versie"
                    aria-expanded={infoOpen}
                    aria-controls="new-version-notice-info"
                    onClick={() => setInfoOpen(open => !open)}
                    onBlur={() => setInfoOpen(false)}
                >
                    <span className="material-symbols-outlined" aria-hidden="true">
                        info
                    </span>
                </button>
                <span
                    id="new-version-notice-info"
                    className="new-version-notice__popover"
                    role="tooltip"
                    onMouseDown={event => event.preventDefault()}
                >
                    Als je om een inhoudelijke of technische reden teruggaat naar de oude versie,
                    geef dat dan vooral door aan{' '}
                    <a href={FEEDBACK_MAILTO}>Jasper</a> of via het{' '}
                    <a href={PRA_BOARD_FORM_URL} target="_blank" rel="noopener noreferrer">
                        PRA board in Asana
                    </a>
                    .
                </span>
            </span>
        </aside>
    );
}
